import axios from "../axios";
import type { WorkBagFormValues } from "../types/workBag.ts";

const JOBBOARD_COMPLETE_PROFILE_TYPE = "PERSON" as const;

function mapWorkZonesToJobBoardPayload(
  workZone: WorkBagFormValues["workZone"]
): { jurisdiccion: number; city: string }[] {
  return workZone
    .map((zone) => {
      const raw =
        typeof zone.jurisdiccion === "object" && zone.jurisdiccion !== null
          ? zone.jurisdiccion.id
          : zone.jurisdiccion;
      const jurisdictionId = Number(raw);
      const cityName = (zone.city || "").trim();
      if (!Number.isFinite(jurisdictionId) || !cityName) {
        return null;
      }
      return { jurisdiccion: jurisdictionId, city: cityName };
    })
    .filter((z): z is { jurisdiccion: number; city: string } => z !== null);
}

export async function saveJobboardProfile(values: WorkBagFormValues) {
  const authToken = localStorage.getItem("access-Token-Edify");
  const config = { headers: { Authorization: `Bearer ${authToken}` } };

  const formData = new FormData();

  formData.append("type", JOBBOARD_COMPLETE_PROFILE_TYPE);
  formData.append("name", values.name.trim());
  formData.append("last_name", values.lastname.trim());
  formData.append("phone", values.phone.trim());

  const skillIds = values.skills
    .map((s) => Number(s.id))
    .filter((id) => Number.isFinite(id));
  formData.append("skillId", skillIds.join(","));

  const categoryIds = values.categoryConnect
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id));
  if (categoryIds.length > 0) {
    formData.append("categoryConnect", categoryIds.join(","));
  }

  const jobBoardZones = mapWorkZonesToJobBoardPayload(values.workZone);
  if (jobBoardZones.length > 0) {
    formData.append("jobBoardZones", JSON.stringify(jobBoardZones));
  }
  formData.append("allCountry", jobBoardZones.length === 0 ? "true" : "false");

  formData.append("unemployment_fund", values.unemploymentFund ? "true" : "false");
  formData.append("current_job", values.currentJob ? "true" : "false");
  if (values.currentJob && values.employmentEndDate) {
    formData.append("employment_end_date", values.employmentEndDate);
  } else {
    formData.append("employment_end_date", "");
  }

  await axios.patch("/user/update", formData, config);
  const userDataResponse = await axios.get("/user/data", config);
  return userDataResponse.data;
}

export const createJobboardPreRegister = (email: string) => {
  return axios.post("/user/create/pre-register", { email });
};

export const createStandardPreRegister = (email: string) => {
  return axios.post("/user/create/pre-register", { email });
};

export const validateJobboardCode = (email: string, code: string) => {
  return axios.post("/user/create/validate-code", { email, code });
};

export const resendJobboardCode = (email: string) => {
  return axios.post("/user/create/resend-code", { email });
};

export const completeJobboardRegistration = (email: string, password: string) => {
  return axios.post("/user/create/job-board", {
    username: email,
    password,
  });
};

export const completeJobboardNewUserRegistration = (email: string, password: string) => {
  return axios.post("/user/create/job-board", {
    username: email,
    password,
  });
};
